/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated provider functions for easy setup
* Do not edit this file manually
*/
import { EnvironmentProviders, Provider, makeEnvironmentProviders } from "@angular/core";
import { HTTP_INTERCEPTORS, HttpInterceptor } from "@angular/common/http";
import { BASE_PATH_FORMATIONAPI, HTTP_INTERCEPTORS_FORMATIONAPI } from "./tokens";
import { FormationApiBaseInterceptor } from "./utils/base-interceptor";

/** Configuration options for formationApi client */
export interface FormationApiConfig {
    /** Base API URL */
    basePath: string;
    /** Enable automatic date transformation (default: true) */
    enableDateTransform?: boolean;
    /** Array of HTTP interceptor classes to apply to this client */
    interceptors?: (new (...args: HttpInterceptor[]) => HttpInterceptor)[];
}

/** Provides configuration for formationApi client */
/** */
/** @example */
/** ```typescript */
/** // In your app.config.ts */
/** import { provideFormationApiClient } from './api/providers'; */
/** */
/** export const appConfig: ApplicationConfig = { */
/**   providers: [ */
/**     provideFormationApiClient({ */
/**       basePath: 'https://api.example.com', */
/**       interceptors: [AuthInterceptor, LoggingInterceptor] // Classes, not instances */
/**     }), */
/**     // other providers... */
/**   ] */
/** }; */
/** ``` */
export function provideFormationApiClient(config: FormationApiConfig): EnvironmentProviders {

    const providers: Provider[] = [
        // Base path token for this client
        {
            provide: BASE_PATH_FORMATIONAPI,
            useValue: config.basePath
        },
        // Base interceptor that handles client-specific interceptors
        {
            provide: HTTP_INTERCEPTORS,
            useClass: FormationApiBaseInterceptor,
            multi: true
        }
    ];

    // Add client-specific interceptor instances
    if (config.interceptors && config.interceptors.length > 0) {
        const interceptorInstances = config.interceptors.map(InterceptorClass => new InterceptorClass());

        // Date transformation not available (dateType: 'string' was used in generation)

        providers.push({
            provide: HTTP_INTERCEPTORS_FORMATIONAPI,
            useValue: interceptorInstances
        });
    } else {
        // No interceptors
        providers.push({
            provide: HTTP_INTERCEPTORS_FORMATIONAPI,
            useValue: []
        });
    }

    return makeEnvironmentProviders(providers);
}
